// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"0b7b84081a72e4cd","417":"30a744f9a4723264"}[chunkId] + ".css";
};